// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"594":"b6c6775f","880":"9ddc2422"}[chunkId] + ".chunk.css";
};